import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import '../tailwind.css'
import apiService from '@/api/service'

// 開發環境下，將 apiService 掛載到全域物件以便調試
if (import.meta.env.DEV) {
    (window as any).apiService = apiService;
    (window as any).checkLoginData = () => {
        console.log('=== 登入資料檢查 ===')
        console.log('是否已登入:', apiService.isLoggedIn())
        console.log('Store Code:', apiService.getCurrentStoreCode())
        console.log('Token:', apiService.getCurrentToken())
        console.log('Login Message:', apiService.getLoginMessage())
        console.log('Login Status:', apiService.getLoginStatus())
        console.log('Is Complete Data:', apiService.getIsCompleteData())
        console.log('Data Complete:', apiService.isDataComplete())
        console.log('Login Timestamp:', apiService.getLoginTimestamp())
        console.log('Complete Login Data:', apiService.getLoginData())
        console.log('==================')
    }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
